import { HttpMethod } from "@/types/https";
import { apiWorkchestraCall } from "../base";
import { ENDPOINT } from "../endpoints";
import { AppConfigResponse } from "../types/config.type";

export const GetAppConfigHandler = () => {
  return {
    name: `GetAppConfigHandler`,
    handle: (): Promise<AppConfigResponse> =>
      apiWorkchestraCall<AppConfigResponse>({
        url: ENDPOINT.CONFIG,
        method: HttpMethod.GET,
      }),
  };
};
